import { motion } from "framer-motion";

/**
 * Renders text the way the "teacher" writes it: in the handwriting face
 * (Caveat), revealed word-by-word with a short stroke animation rather
 * than a typewriter fade — this is the single highest-leverage visual
 * cue separating "classroom" from "chatbot" (master plan §7).
 */
export function HandwrittenText({
  text,
  highlighted = false,
  className,
}: {
  text: string;
  highlighted?: boolean;
  className?: string;
}) {
  const words = text.split(" ");

  return (
    <span className={className}>
      {words.map((word, i) => (
        <motion.span
          key={`${text}-${i}`}
          className={`handwritten inline-block mr-[0.3em] ${highlighted ? "highlighter-swipe" : ""}`}
          initial={{ clipPath: "inset(0 100% 0 0)" }}
          animate={{ clipPath: "inset(0 0% 0 0)" }}
          transition={{ duration: 0.28, delay: i * 0.12, ease: "easeOut" }}
        >
          {word}
        </motion.span>
      ))}
    </span>
  );
}
